import { AnyAppEvent, AppEvent } from "../appEvent.types";

const eventName = "issue-badges" as const;

export type IssueBadgesEventData = {
  tickets: Array<{
    quantity: number;
    exhibitorId?: string | null;
    commercialId?: string | null;
    visitorId?: string | null;
  }>;
  eventId: string;
};
export type IssueBadgesEvent = AppEvent<typeof eventName, IssueBadgesEventData>;

export const isIssueBadgesEvent = (
  event: AnyAppEvent
): event is IssueBadgesEvent => event.name === eventName;

export { eventName as issueBadges };
